import { lazy, Suspense } from 'react';
import { createBrowserRouter, Outlet } from 'react-router-dom';

import { InternalAppGuard } from '@climatepartner/app-shell';
import { Spinner } from '@climatepartner/components';

import RouteNotFound from '@pages/route-not-found';

import { ReviewOfflineStorageProvider } from './adapters/review.offline-storage';
import ErrorBoundary from './components/error-boundary';
import PageLayout from './layouts/page-layout';
import ReviewLayout from './layouts/review-layout';
import SearchLayout from './layouts/search-layout';

const SingleSearch = lazy(() => import('@pages/single-search'));
const MultiSearch = lazy(() => import('@pages/multi-search'));
const Faq = lazy(() => import('@pages/faq'));
const Job = lazy(() => import('@pages/job/job'));

export default createBrowserRouter([
    {
        element: (
            <ErrorBoundary>
                <PageLayout>
                    <InternalAppGuard>
                        <Outlet />
                    </InternalAppGuard>
                </PageLayout>
            </ErrorBoundary>
        ),
        children: [
            {
                element: (
                    <SearchLayout>
                        <Outlet />
                    </SearchLayout>
                ),
                children: [
                    {
                        path: '/',
                        element: (
                            <Suspense fallback={<Spinner isFixed />}>
                                <SingleSearch />
                            </Suspense>
                        ),
                    },
                    {
                        path: '/multi-search/*',
                        element: (
                            <Suspense fallback={<Spinner isFixed />}>
                                <MultiSearch />
                            </Suspense>
                        ),
                    },
                ],
            },
            {
                path: '/multi-search/job/:jobId',
                element: (
                    <ReviewLayout>
                        <ReviewOfflineStorageProvider>
                            <Suspense fallback={<Spinner isFixed />}>
                                <Job />
                            </Suspense>
                        </ReviewOfflineStorageProvider>
                    </ReviewLayout>
                ),
            },
            {
                path: '/faq',
                element: (
                    <Suspense fallback={<Spinner isFixed />}>
                        <Faq />
                    </Suspense>
                ),
            },
            {
                path: '*',
                element: <RouteNotFound />,
            },
        ],
    },
]);
